/* eslint-disable symbol-description */

/**
 * @param {string} description
 */
const _Symbol = description => Symbol(description)

/**
 * G - Gaia Library Static Definitions.
 */
const G = Object.freeze({
  APP: _Symbol('app'),
  PROVIDER: _Symbol('provider'),
  EVENTS: _Symbol('events'),
  API: _Symbol('api'),
  CONFIGURATION: _Symbol('configuration'),
  MODULE: _Symbol('module'),
  ACTION: _Symbol('action'),
  HOOKS: _Symbol('hooks'),
  MODEL: _Symbol('model'),
  VIEW: _Symbol('view'),
  COMPONENT: _Symbol('component'),
  CHILDREN: _Symbol('children'),
  ACTIONS: _Symbol('actions'),
  TEMPLATE: _Symbol('template'),
  PLATFORM: _Symbol('platform'),
  OS: _Symbol('os'),

  FN: _Symbol('fn'),
  SESSION: _Symbol('session'),
  ERROR: _Symbol('error'),
  GROUP: _Symbol('group'),
  FILTER: _Symbol('filter'),
  PARENT: _Symbol('parent'),
  ONLINE: _Symbol('online'),
  LANGUAGE: _Symbol('language'),
  ROUTE: _Symbol('route'),
  CONTEXT: _Symbol('context'),
  CURRENT: _Symbol('current'),
  NEXT: _Symbol('next'),
  PREV: _Symbol('prev'),
  ORIGIN: _Symbol('origin'),
  USER: _Symbol('user'),

  STATE: _Symbol('state'),
  PROPS: _Symbol('props'),
  CACHE: _Symbol('cache'),
  DATA: _Symbol('data'),
  VALIDATOR: _Symbol('validator'),
  DECORATOR: _Symbol('decorator'),
  TRANSFORMER: _Symbol('transformer'),

  LIST: _Symbol('list'),
  META: _Symbol('meta'),
  LIMIT: _Symbol('limit'),
  OFFSET: _Symbol('offset'),
  PAGE: _Symbol('page'),

  KEYS: _Symbol('keys'),
  KEY: _Symbol('key'),
  REF: _Symbol('ref'),

  ADAPTER: _Symbol('adapter'),
  UI: _Symbol('ui'),
  ROUTER: _Symbol('router'),
  HTTP: _Symbol('http'),
  INTL: _Symbol('intl'),
  ATTACHMENT: _Symbol('attachment'),
  MESSAGE: _Symbol('message'),
  NOTE: _Symbol('note'),
  NOTIFICATION: _Symbol('notification'),
  CART: _Symbol('cart'),
  PLUGIN: _Symbol('plugin'),
  SETTINGS: _Symbol('settings'),
  PUBSUB: _Symbol('pubsub'),
  STORAGE: _Symbol('storage'),
  PERSISTENCE: _Symbol('persistence'),

  MODAL: _Symbol('modal'),
  DRAWER: _Symbol('drawer'),
  FRAME: _Symbol('frame'),
  MENU: _Symbol('menu'),
  SEARCH: _Symbol('search'),

  CREATE: _Symbol('create'),
  READ: _Symbol('read'),
  WRITE: _Symbol('write'),
  UPDATE: _Symbol('update'),
  DELETE: _Symbol('delete'),
  DRAFT: _Symbol('draft'),
  ACTIVATE: _Symbol('activate'),
  ADD: _Symbol('add'),
  REMOVE: _Symbol('remove'),
  APPLY: _Symbol('apply'),
  UNDO: _Symbol('undo'),
  INIT: _Symbol('init'),
  DESTROY: _Symbol('destroy'),
  DONE: _Symbol('done'),
  ACL: _Symbol('acl'),
  BULK: _Symbol('bulk'),
  SET: _Symbol('set'),
  CHANGE: _Symbol('change'),
  INSERT: _Symbol('insert'),
  CLEAN: _Symbol('clean'),
  LOAD: _Symbol('load'),
  PIN: _Symbol('pin'),
  SCROLL: _Symbol('scroll'),
  UPLOAD: _Symbol('upload'),
  PROGRESS: _Symbol('progress'),
  CANCEL: _Symbol('cancel'),

  CLIPBOARD: _Symbol('clipboard'),
  KEYBOARD: _Symbol('keyboard'),

  BLUETOOTH: _Symbol('bluetooth'),
  SCAN: _Symbol('scan'),
  DISCOVER: _Symbol('discover'),
  RESET: _Symbol('reset'),
})

module.exports = G
